
/* styles */
require("!!../../extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true,\"publicPath\":\"../../\"}!vue-style-loader!css-loader?{\"minimize\":true,\"sourceMap\":true}!../../vue-loader/lib/style-compiler/index?{\"id\":\"data-v-6e3fadf0\",\"scoped\":true,\"hasInlineConfig\":false}!../../vue-loader/lib/selector?type=styles&index=0!./resize-bar.vue")

var Component = require("!../../vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../vue-loader/lib/selector?type=script&index=0!./resize-bar.vue"),
  /* template */
  require("!!../../vue-loader/lib/template-compiler/index?{\"id\":\"data-v-6e3fadf0\"}!../../vue-loader/lib/selector?type=template&index=0!./resize-bar.vue"),
  /* scopeId */
  "data-v-6e3fadf0",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./~/vue-core-image-upload/dist/resize-bar.vue
// module id = 264
// module chunks = 0